import { render, staticRenderFns } from "./MobileLanguagePicker.vue?vue&type=template&id=efd814f6&lang=html&"
import script from "./MobileLanguagePicker.vue?vue&type=script&lang=js&"
export * from "./MobileLanguagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd814f6')) {
      api.createRecord('efd814f6', component.options)
    } else {
      api.reload('efd814f6', component.options)
    }
    module.hot.accept("./MobileLanguagePicker.vue?vue&type=template&id=efd814f6&lang=html&", function () {
      api.rerender('efd814f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileMenuComponents/MobileLanguagePicker.vue"
export default component.exports